module.exports = __webpack_public_path__ + "static/img/icon_googlepay.17708cb2.png";